import {
  ButtonAvailability,
  ButtonContainer,
  ButtonContainerWrapper,
  ButtonDate,
  ButtonDateWrapper,
  ButtonWeekDay,
  NotAvailableText,
} from './styles';
import { DatePickerButtonProps } from './types';

// eslint-disable-next-line no-restricted-properties
export const Button = ({
  active,
  date,
  weekday,
  isShefMenu,
  innerRef,
  isPastDate,
  isUnavailable,
  availability,
  ...restOfProps
}: DatePickerButtonProps): JSX.Element => {
  const sharedButtonProps = { active, isPastDate, isUnavailable };
  return (
    <ButtonContainer ref={innerRef} {...sharedButtonProps} {...restOfProps}>
      <ButtonContainerWrapper>
        <ButtonDateWrapper>
          <ButtonWeekDay {...sharedButtonProps}>{weekday}</ButtonWeekDay>
          <ButtonDate {...sharedButtonProps}>{date}</ButtonDate>
        </ButtonDateWrapper>
        {!isShefMenu && <ButtonAvailability>{availability}</ButtonAvailability>}
      </ButtonContainerWrapper>
      {isShefMenu && isUnavailable && !isPastDate && <NotAvailableText>This shef is not available</NotAvailableText>}
    </ButtonContainer>
  );
};
